import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { DigipoortModal } from './digipoort-modal/digipoort-modal.component';
import { SbrNexusModal } from './sbr-nexus-modal/sbr-nexus-modal.component';
import { SettingsService } from '../../settings.service';
import { PermissionsEnum, PlatformSettings } from 'src/app/constants/settings.enum';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { XbrlrenderserviceModalComponent } from './xbrlrenderservice-modal/xbrlrenderservice-modal.component';
import { DigipoortFlow } from 'src/app/constants/digipoort-flow.enum';

@Component({
  templateUrl: './services.page.html'
})
export class ServicesPage implements OnDestroy {
  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;
  
  sbrNexus: string = "";
  digipoort: string = "";
  flow: DigipoortFlow = DigipoortFlow.Happyflow;
  xbrlRenderService: string = "";

  environment = environment;
  orgSettings!: any;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private organisationApiClient: OrganisationApiClient, private modalService: NgbModal, private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
        if (organisationId === this.selectedOrganisationId) return;
        this.selectedOrganisationId = organisationId;
        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Integrations(this.selectedOrganisationId), BreadCrumbOptions.Integrations_Services(this.selectedOrganisationId));

        this.getOrganisationPlugins();
      });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getOrganisationPlugins() {
    let servicesSettings: PlatformSettings[] = [PlatformSettings.DigipoortEnvironment, PlatformSettings.AansluitSuiteAanleverKenmerk, PlatformSettings.SBRNexusEnvironment, PlatformSettings.XbrlRenderClient];

    await this.organisationApiClient.getOrganisationSettingsByFilter(this.selectedOrganisationId, servicesSettings).subscribe({
      next: (settings: any) => {
        let returnObject: any = {};
        settings.forEach((setting: any) => {
          returnObject[setting.key] = setting.value;
        });
        this.orgSettings = returnObject;
        this.flow = this.orgSettings.AansluitSuiteAanleverKenmerk as DigipoortFlow;
        this.digipoort = this.orgSettings.DigipoortEnvironment;
        this.sbrNexus = this.orgSettings.SBRNexusEnvironment;
        this.xbrlRenderService = this.orgSettings.xbrlRenderClient;
      }
    });
  }

  openDigipoortModal(): void {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };
    let modalRef = this.modalService.open(DigipoortModal, ngbModalOptions);
    modalRef.componentInstance.digipoort = this.digipoort;
    modalRef.componentInstance.flow = this.flow;
    modalRef.componentInstance.environment = this.environment;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item: any) => {
      this.orgSettings.DigipoortEnvironment = item[0].value;
      this.digipoort = item[0].value;
      this.flow = item[1].value;
      this.settingsService.updateSettings(item, this.selectedOrganisationId);
      modalRef.close();
    });
  }

  openSbrNexusModal(): void {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };
    let modalRef = this.modalService.open(SbrNexusModal, ngbModalOptions);
    modalRef.componentInstance.sbrNexus = this.sbrNexus;
    modalRef.componentInstance.environment = this.environment;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item: any) => {
      this.orgSettings.SBRNexusEnvironment = item[0].value;
      this.sbrNexus = item[0].value;
      this.settingsService.updateSettings(item, this.selectedOrganisationId);
      modalRef.close();
    });
  }

  openXBRLrenderserviceModal(): void {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };
    let modalRef = this.modalService.open(XbrlrenderserviceModalComponent, ngbModalOptions);
    modalRef.componentInstance.xbrlRenderService = this.xbrlRenderService;
    modalRef.componentInstance.environment = this.environment;
    modalRef.componentInstance.updateOrganisationSettings.subscribe(async (item: any) => {
      this.orgSettings.XbrlRenderClient = item[0].value;
      this.xbrlRenderService = item[0].value;
      this.settingsService.updateSettings(item, this.selectedOrganisationId);
      modalRef.close();
    });
  }
}
